import { render, staticRenderFns } from "./ChairmanSpeech.vue?vue&type=template&id=01d8c04c&scoped=true&"
import script from "./ChairmanSpeech.vue?vue&type=script&lang=js&"
export * from "./ChairmanSpeech.vue?vue&type=script&lang=js&"
import style0 from "./ChairmanSpeech.vue?vue&type=style&index=0&id=01d8c04c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d8c04c",
  null
  
)

export default component.exports